import { ArcolExport } from "./types";

const REQUIRED_FIELDS: (keyof ArcolExport)[] = ["project_name", "buildings"];

function validateArcolJson(data: unknown): data is ArcolExport {
  if (typeof data !== "object" || data === null) return false;
  const obj = data as Record<string, unknown>;

  for (const field of REQUIRED_FIELDS) {
    if (!(field in obj)) return false;
  }

  if (!Array.isArray(obj.buildings) || obj.buildings.length === 0) return false;

  return true;
}

export const selectJsonFile = (): Promise<ArcolExport> => {
  return new Promise((resolve, reject) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".json";
    input.style.display = "none";

    input.onchange = (e: Event) => {
      const target = e.target as HTMLInputElement;
      const file = target.files?.[0];

      if (!file) {
        reject(new Error("No file selected"));
        cleanup();
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        try {
          const parsed = JSON.parse(event.target?.result as string);
          if (!validateArcolJson(parsed)) {
            reject(new Error("Invalid Arcol JSON: missing required fields (project_name, buildings)"));
            return;
          }
          resolve(parsed);
        } catch (err) {
          reject(new Error(`Failed to parse JSON: ${err instanceof Error ? err.message : String(err)}`));
        } finally {
          cleanup();
        }
      };
      reader.onerror = () => {
        reject(new Error("Failed to read file"));
        cleanup();
      };
      reader.readAsText(file);
    };

    function cleanup() {
      document.body.removeChild(input);
    }

    document.body.appendChild(input);
    input.click();
  });
};
